<template>
  <div class="file-video">
    <video controls :poster="file.thumbnail_64" class="video max-digitalmedia-width">
      <source :src="file.file_64" />
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
export default {
  name: "FileVideo",
  props: {
    file: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.video {
  width: 100%;
  border-radius: 8px;
}
</style>